export default __webpack_public_path__ + "static/laureat-RE-rhone-73f3d0dfade8cdeab3bb49fe9c5262ff.png";